module.exports = __webpack_public_path__ + "img/BuyCard.df8fc699.jpg";